import type { ReactNode } from 'react'
import React from 'react'
import { LLVLocaleProvider } from '@systemeio/light-lecture-viewer'
import { useTranslation } from 'next-i18next/pages'
import Head from 'next/dist/shared/lib/head'
import { FAVICON_LINK_KEYS } from 'shared/constants'
import { LocaleEnum } from 'shared/enums/locale-enum'
import useUser from 'shared/hooks/use-user'
import type { DomainAssetsInterface } from 'shared/types/domain'
import Header from 'modules/header'
import { useBrand } from 'modules/white-label/contexts/brand-context'

interface Props extends React.PropsWithChildren {
  domainAssets?: DomainAssetsInterface
}

function SchoolLayout({ children, domainAssets }: Props): ReactNode {
  const { t } = useTranslation()
  const { user } = useUser()

  const { brand } = useBrand()

  return (
    <>
      <Head>
        <title>{t('browser_tab_title.school')}</title>
        {domainAssets?.faviconUrl && (
          <link key={FAVICON_LINK_KEYS.icon} rel="icon" href={domainAssets.faviconUrl} />
        )}
      </Head>
      <Header
        logoSrc={domainAssets?.logoUrl || brand.logo?.path}
        className="bg-bg-primary!"
        headerContainerClassName="mx-auto max-w-(--breakpoint-2xl) px-5 sm:px-5 md:px-5"
      />
      <LLVLocaleProvider locale={user?.dashboardLocale || LocaleEnum.ENGLISH}>
        <div className="mx-auto max-w-(--breakpoint-2xl) px-5 pb-4 lg:pb-9">{children}</div>
      </LLVLocaleProvider>
    </>
  )
}

export const getSchoolLayout = (
  page: ReactNode,
  props: { domainAssets?: DomainAssetsInterface },
): ReactNode => <SchoolLayout domainAssets={props.domainAssets}>{page}</SchoolLayout>
